/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ErsStatusEnumDTO } from './ers-status-enum-dto';
import { EntityReportStateEnumDTO } from './entity-report-state-enum-dto';
import { ErsDeviceTypeEnumDTO } from './ers-device-type-enum-dto';
import { EntityErrorsDTO } from './entity-errors-dto';
import { StatusLogDTO } from './status-log-dto';


/**
 * Ers with status log information.
 */
export interface ErsWithStatusLogDTO { 
    /**
     * Represents the internal id of the associated business premises
     */
    businessPremisesId: string;
    /**
     * System generated UID for the ERS
     */
    id: string;
    /**
     * Represents the internal id of the TSS entity
     */
    tssEntityId?: string;
    /**
     * Represents the internal id of the associated organization
     */
    organizationId?: string;
    /**
     * External ERS ID (unique per customer tenant). AO §146a seriennummerAS
     */
    ersSerialNumber?: string;
    /**
     * Optional description of the entity
     */
    detailedDescription?: string;
    /**
     * Identifier of ERS
     */
    ersIdentifier?: string;
    /**
     * Optional type of client
     */
    type?: string;
    status?: ErsStatusEnumDTO;
    /**
     * Vendor description of the ERS hardware. AO §146a hersteller
     */
    brand?: string;
    /**
     * ERS hardware model. AO §146a modell
     */
    model?: string;
    /**
     * Software installed on the device. AO §146a software
     */
    software?: string;
    /**
     * Optional version of the ERS. AO §146a softwareVersion
     */
    version?: string;
    deviceType?: ErsDeviceTypeEnumDTO;
    /**
     * The date of acquiring the ERS. Validation rules for creating and updating:   * The date cannot be in the future.   * The date must be before or equal to `commissioningDate`.  AO §146a anschaffungAS. 
     */
    acquisitionDate?: string;
    /**
     * The date of putting the ERS out of operation. It overwrites `deactivationDate` and it used for AO §146a ausserbetriebnahmeAS 
     */
    decommissionDate?: string;
    /**
     * Date of the first connection with TSS
     */
    firstConnectionEstablishedDate?: string;
    /**
     * Tax office remark. AO §146a bemerkungen
     */
    taxOfficeRemark?: string;
    /**
     * Deactivation reason. AO §146a grundAusserbetriebnahme
     */
    deactivationReason?: string;
    /**
     * The datetime when the ERS was activated. It should be set automatically when ERS is activated. 
     */
    activationDate?: string;
    /**
     * The datetime field that will be set when ERS is set to disabled. It is used for AO §146a ausserbetriebnahmeAS and it can be overwritten by `decommissionDate` 
     */
    deactivationDate?: string;
    /**
     * The datetime when the ERS was commissioned. This datetime field is set automatically when ERS is the first connected to a Virtual TSS and it is not filled yet (not for external ERS).  Validation rules for creating and updating:   * The date cannot be in the future.   * The date must be before or equal to `firstConnectionEstablishedDate` (ERS) or `tssConnectionDate` (External ERS)   * The date must be after or equal to `acquisitionDate`   * The date must be before or equal to `decommissionDate`  AO §146a inbetriebnahmeAS. 
     */
    commissioningDate?: string;
    submissionDisabledReportState?: EntityReportStateEnumDTO;
    errors?: EntityErrorsDTO;
    /**
     * Creation date
     */
    createdDate?: string;
    /**
     * Date of last change
     */
    lastModifiedDate?: string;
    /**
     * Created by
     */
    createdBy?: string;
    /**
     * Last modified by
     */
    lastModifiedBy?: string;
    statusLogs?: Array<StatusLogDTO>;
}

export class ClsErsWithStatusLogDTO { 
    /**
     * Represents the internal id of the associated business premises
     */
    businessPremisesId: string = undefined;
    /**
     * System generated UID for the ERS
     */
    id: string = undefined;
    /**
     * Represents the internal id of the TSS entity
     */
    tssEntityId?: string = undefined;
    /**
     * Represents the internal id of the associated organization
     */
    organizationId?: string = undefined;
    /**
     * External ERS ID (unique per customer tenant). AO §146a seriennummerAS
     */
    ersSerialNumber?: string = undefined;
    /**
     * Optional description of the entity
     */
    detailedDescription?: string = undefined;
    /**
     * Identifier of ERS
     */
    ersIdentifier?: string = undefined;
    /**
     * Optional type of client
     */
    type?: string = undefined;
    status?: ErsStatusEnumDTO = undefined;
    /**
     * Vendor description of the ERS hardware. AO §146a hersteller
     */
    brand?: string = undefined;
    /**
     * ERS hardware model. AO §146a modell
     */
    model?: string = undefined;
    /**
     * Software installed on the device. AO §146a software
     */
    software?: string = undefined;
    /**
     * Optional version of the ERS. AO §146a softwareVersion
     */
    version?: string = undefined;
    deviceType?: ErsDeviceTypeEnumDTO = undefined;
    /**
     * The date of acquiring the ERS. Validation rules for creating and updating:   * The date cannot be in the future.   * The date must be before or equal to `commissioningDate`.  AO §146a anschaffungAS. 
     */
    acquisitionDate?: string = undefined;
    /**
     * The date of putting the ERS out of operation. It overwrites `deactivationDate` and it used for AO §146a ausserbetriebnahmeAS 
     */
    decommissionDate?: string = undefined;
    /**
     * Date of the first connection with TSS
     */
    firstConnectionEstablishedDate?: string = undefined;
    /**
     * Tax office remark. AO §146a bemerkungen
     */
    taxOfficeRemark?: string = undefined;
    /**
     * Deactivation reason. AO §146a grundAusserbetriebnahme
     */
    deactivationReason?: string = undefined;
    /**
     * The datetime when the ERS was activated. It should be set automatically when ERS is activated. 
     */
    activationDate?: string = undefined;
    /**
     * The datetime field that will be set when ERS is set to disabled. It is used for AO §146a ausserbetriebnahmeAS and it can be overwritten by `decommissionDate` 
     */
    deactivationDate?: string = undefined;
    /**
     * The datetime when the ERS was commissioned. This datetime field is set automatically when ERS is the first connected to a Virtual TSS and it is not filled yet (not for external ERS).  Validation rules for creating and updating:   * The date cannot be in the future.   * The date must be before or equal to `firstConnectionEstablishedDate` (ERS) or `tssConnectionDate` (External ERS)   * The date must be after or equal to `acquisitionDate`   * The date must be before or equal to `decommissionDate`  AO §146a inbetriebnahmeAS. 
     */
    commissioningDate?: string = undefined;
    submissionDisabledReportState?: EntityReportStateEnumDTO = undefined;
    errors?: EntityErrorsDTO = undefined;
    /**
     * Creation date
     */
    createdDate?: string = undefined;
    /**
     * Date of last change
     */
    lastModifiedDate?: string = undefined;
    /**
     * Created by
     */
    createdBy?: string = undefined;
    /**
     * Last modified by
     */
    lastModifiedBy?: string = undefined;
    statusLogs?: Array<StatusLogDTO> = undefined;
}



